export const isValidExcelCell = (input) => {
  const match = input.toUpperCase().match(/^([A-Z]+)([1-9][0-9]*)$/);
  if (!match) return false;

  const [_, colLetters, rowStr] = match;
  const row = parseInt(rowStr, 10);

  if (row < 1 || row > 1048576) return false;

  // Convert column letters to a number (e.g., A=1, Z=26, AA=27, etc.)
  let colNum = 0;
  for (let i = 0; i < colLetters.length; i++) {
    colNum *= 26;
    colNum += colLetters.charCodeAt(i) - 64; // 'A' is 65
  }

  return colNum >= 1 && colNum <= 16384;
};

export const requiredExcelFileExtensions = ".xlsx,.xlsm,.xltx,.xltm";

export const extendedRequiredExcelFileExtensions = ".xls,.xlsx,.xlsm,.xltx,.xltm";